import { render } from "./EditableTable.vue?vue&type=template&id=b51a011a"
import script from "./EditableTable.vue?vue&type=script&lang=js"
export * from "./EditableTable.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__